/* eslint-disable */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AdaptiveService, customerConfig, Locale, SsoService, SsoPages, LocaleMapperService } from '@uxdf/direct-shared-lib';
import { Item, Menu } from '../../../../redux/models/menu';
import { MenuItem, MenuItemImpl, SSO_CODES } from '../menu-item.model';
import { animate, style, transition, trigger } from '@angular/animations';
import { Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { State } from '../../../../redux/reducers';
import { UpdateProfileSuccess } from '../../../../redux/actions/account/actions-profile';
import { DOCUMENT } from '@angular/common';
import { isOn } from 'feature-toggle-service';
import { FooterMenuItem } from '../../homepage.model';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],


  animations: [
    trigger('appear', [
      transition(':enter', [style({ opacity: 0 }), animate(200, style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate(200, style({ opacity: 0 }))])
    ]),
    trigger('contentToggle', [
      transition(':enter', [style({ height: 0 }), animate('300ms ease-in-out', style({ height: '*' }))]),
      transition(':leave', [style({ height: '*' }), animate('300ms ease-in-out', style({ height: 0 }))])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() contact: {};
  @Input() set socials(links: { [title: string]: string }) {
    if (links !== undefined) {
      this.socialLinks = Object.entries(links).filter(([_, link]) => link);
    }
  }
  @Input()
  set menu(menu: Menu) {
    this.topLinks = menu.footer ? menu.footer.map(item => {
      const menuItem = new MenuItemImpl(item);

      // Exclude children with these codes
      const excludeCodes = ['SERVICE_HUB', 'COMMUNITY', 'PLUSME_SUPPORT', 'connect'];

      menuItem.children = menuItem.children.filter(child => {
        return !excludeCodes.includes(child.code);
      });

      return menuItem;
    }) : [];
    this.legalLinks = menu.legal ? menu.legal.filter(({ item_type }) => 'cms_page' === item_type) : [];
  }

  public customerConfig$: Observable<any>;

  locales: Locale[] = [];
  localesSubscription: Subscription;
  ssoCodes = SSO_CODES;
  topLinks: MenuItem[] = [];
  socialLinks: [string, string][] = [];
  legalLinks: Item[] = [];
  scrollTop = 0;
  isMobile = true;

  defaultEasingLogic;

  stores = [];

  isCountryEnabledWithEdenred = false;
  isCountryEnabledWithPlusMe = false;
  isEdenredADSupportFlowEnabled = isOn('PLUSME_CUS_SUPPORT_A');

  constructor(
    private readonly ssoService: SsoService,
    private readonly adaptiveService: AdaptiveService,
    private readonly store: Store<State>,
    private readonly cd: ChangeDetectorRef,
    private readonly localeMapperService: LocaleMapperService,
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject('e2eMode') public readonly e2eMode,
    @Inject('EdenredSupportedCountries') private readonly edenredCountries
  ) {
    this.customerConfig$ = this.store.pipe(select(customerConfig));
    this.customerConfig$.subscribe(response => {
      if (response.customerConfig && !response.isLoading) {
        this.stores = response.customerConfig.stores;

        for (const country of this.edenredCountries.countryList) {
          if (response.customerConfig.country_code === country) {
            this.isCountryEnabledWithEdenred = true;
            break;
          }
        }
        this.isCountryEnabledWithPlusMe = response.customerConfig.loyalty_enabled_for_account;
      }
    });

    this.defaultEasingLogic = (t: number, b: number, c: number, d: number): number => {
      if (t === 0) {
        return b;
      }
      if (t === d) {
        return b + c;
      }
      t /= d / 2;
      if (t < 1) {
        return (c / 2) * Math.pow(2, 10 * (t - 1)) + b;
      }
      return (c / 2) * (-Math.pow(2, -10 * (t - 1)) + 2) + b;
    };
  }

  navigateBySSOLink(menuItem: FooterMenuItem) {
    this.ssoService.redirectToSupportPage(menuItem);
  }

  menuTrackBy(index: number, item: MenuItem) {
    return item.children.reduce((acc, v) => acc + v.code, '');
  }

  // redraw drops svg icons
  itemTrackBy(index: number, item: MenuItem) {
    return item.code;
  }

  setLang(item) {
    // update session storage landing values
    this.store.dispatch(new UpdateProfileSuccess(true));
    this.localeMapperService.updateLandingAndCookie(item.locale, item.store_code);
    this.localeMapperService.updateSessionAndLanguageService(item.locale, item.store_code);
    this.document.location.reload();
  }

  scrolled(document: HTMLDocument) {
    const element = document.scrollingElement || document.documentElement;
    this.scrollTop = element.scrollTop;
  }

  ngOnInit() {
    this.isMobile = this.adaptiveService.isMobile();
    if (!this.isMobile) {
      this.topLinks = this.topLinks.map(link => Object.assign(link, { opened: true }));
    }
  }

  ngOnDestroy() {
    if (this.localesSubscription && this.localesSubscription.closed) {
      this.localesSubscription.unsubscribe();
    }
  }

  onResize() {
    this.isMobile = this.adaptiveService.isMobile();
    this.topLinks = this.topLinks.map(link => Object.assign(link, { opened: !this.isMobile }));
    this.cd.detectChanges();
  }

  refineItems(children) {
    return children.filter(element => {
      // feature is not enabled for the account - remove Edenred support
      if (!this.isEdenredADSupportFlowEnabled && element.code === SsoPages.EDENRED_SUPPORT) {
        return false;
      }
      // feature enabled, but +Me is not available -> remove Edenred support
      if (!this.isCountryEnabledWithPlusMe && element.code === SsoPages.EDENRED_SUPPORT) {
        return false;
      }
      // +Me available but Edenred gift store not enabled -> remove Edenred support
      if (!this.isCountryEnabledWithEdenred && element.code === SsoPages.EDENRED_SUPPORT) {
        return false;
      }
      // Keep the element
      return true;
    });
  }
}
